import React, { useState } from "react";
import {
  FaUsers,
  FaKey,
  FaLayerGroup,
  FaShieldAlt,
  FaLink,
  FaUserCog,
} from "react-icons/fa";
import { MdAppRegistration } from "react-icons/md";
import { MdSecurity, MdDashboard } from "react-icons/md";
import { CgMenuGridO } from "react-icons/cg";
import { AiOutlineCloseCircle } from "react-icons/ai";
import { Link, useLocation } from "react-router-dom";
import { SiGoogleads } from "react-icons/si";
import { useAuth } from "../Auth/AuthContext";
import { pagePermissions } from "../../utils/permissionConfig";

const Sidebar = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const location = useLocation();
  const { user, hasPermission } = useAuth();

  const menuItems = [
    {
      label: "Dashboard",
      icon: <MdDashboard />,
      path: "/dashboard",
      show: hasPermission(
        pagePermissions.dashboard.resource,
        pagePermissions.dashboard.action
      ),
    },
    {
      label: "Potential Leads",
      icon: <SiGoogleads />,
      path: "/potential-leads",
      show: hasPermission(
        pagePermissions.potentialLeads.resource,
        pagePermissions.potentialLeads.action
      ),
    },
    {
      label: "Lead Form",
      icon: <FaUsers />,
      path: "/lead-form",
      show: hasPermission(
        pagePermissions.leadForm.resource,
        pagePermissions.leadForm.action
      ),
    },
    {
      label: "Pending Registration",
      icon: <MdAppRegistration />,
      path: "/pending-registration",
      show: hasPermission(
        pagePermissions.pendingRegistration.resource,
        pagePermissions.pendingRegistration.action
      ),
    },
    {
      label: "Pending Training",
      icon: <FaLayerGroup />,
      path: "/pending-training",
      show: hasPermission(
        pagePermissions.pendingTraining.resource,
        pagePermissions.pendingTraining.action
      ),
    },
    {
      label: "Agent Management",
      icon: <FaUserCog />,
      path: "/agent-management",
      show: hasPermission(
        pagePermissions.agentManagement.resource,
        pagePermissions.agentManagement.action
      ),
    },
    // {
    //   label: "Disqualified Registration",
    //   icon: <FaUserCog />,
    //   path: "/disqualified-registration",
    //   show: hasPermission(
    //     pagePermissions.agentManagement.resource,
    //     pagePermissions.agentManagement.action
    //   ),
    // },
  ];

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  return (
    <div className="relative">
      <aside
        className={`fixed top-0 left-0 h-screen 
          bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900
          backdrop-blur-md
          border-r border-white/10
          text-white z-40 sm:w-64 w-60 
          shadow-lg
          transition-all duration-300 ease-in-out 
          ${isSidebarOpen ? "translate-x-0" : "-translate-x-full"} 
          sm:translate-x-0`}
      >
        <div className="relative w-full flex flex-col items-center py-6 mb-4 border-b border-white/10 bg-black/20">
          <div className="flex items-center gap-2">
            <span className="text-2xl font-bold text-pink-400 tracking-wider">
              Snabbit
            </span>
            <span className="text-2xl font-bold text-white tracking-wider">
              Lead Gen
            </span>
            <span>
              {isSidebarOpen && (
                <button
                  onClick={toggleSidebar}
                  className="fixed top-4 left-4 sm:hidden z-50 p-2 rounded-full bg-gray-900 shadow-lg hover:bg-gray-800 transition-colors"
                >
                  <AiOutlineCloseCircle size={24} className="text-white" />
                </button>
              )}
            </span>
          </div>
        </div>
        <ul className="relative flex flex-col gap-2 w-full px-4">
          {menuItems.filter(menu => menu.show).map((menu, index) => (
            <li key={index} className="w-full">
              <Link
                to={menu.path}
                className={`flex items-center gap-4 w-full h-12 px-4 rounded-lg text-left transition-all duration-200
                  ${
                    location.pathname === menu.path
                      ? "bg-white/10 text-white shadow-lg border border-white/20"
                      : "text-white/80 hover:bg-white/5 hover:text-white"
                  }`}
              >
                <span
                  className={`text-xl ${
                    location.pathname === menu.path ? "text-pink-400" : ""
                  }`}
                >
                  {menu.icon}
                </span>
                <span className="flex-1 text-base font-medium">
                  {menu.label}
                </span>
                {location.pathname === menu.path && (
                  <div className="absolute left-0 w-1 h-8 bg-pink-400 rounded-r-full" />
                )}
              </Link>
            </li>
          ))}
        </ul>
      </aside>

      {!isSidebarOpen && (
        <button
          onClick={toggleSidebar}
          className="fixed top-4 left-4 sm:hidden z-50 p-2 rounded-full
          bg-gray-900
          shadow-lg
          hover:bg-gray-800 transition-colors"
        >
          <CgMenuGridO size={24} className="text-white" />
        </button>
      )}

      {isSidebarOpen && (
        <div
          className="fixed inset-0 bg-black/50 backdrop-blur-sm z-30 sm:hidden transition-opacity"
          onClick={toggleSidebar}
        ></div>
      )}
    </div>
  );
};

export default Sidebar;
